export const hasValidContent = value => {
  if (!value) return false;

  const items = Array.isArray(value) ? value : [value];

  return items.some(item => {
    if (!item || typeof item !== 'string') {
      return false;
    }

    const cleaned = item.trim();

    // evita ".", "..", "..."
    if (/^\.+$/.test(cleaned)) {
      return false;
    }

    return cleaned.length > 0;
  });
};
